module.exports = __webpack_public_path__ + "img/values-2.ff052f01.jpg";